import { useEffect } from "react";

/**
 * Custom hook to handle Escape key press for closing modals
 *
 * @param {Function} onClose - Callback to close the modal
 * @param {boolean} enabled - Whether the escape handler is enabled (default: true)
 */
export const useModalEscape = (onClose, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose, enabled]);
};

export default useModalEscape;
